import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['input']
  static values = { url: String, frame: String }

  declare readonly inputTarget: HTMLInputElement
  declare urlValue: string
  declare frameValue: string

  private timeout: ReturnType<typeof setTimeout> | null = null

  search(): void {
    if (this.timeout) clearTimeout(this.timeout)

    this.timeout = setTimeout(() => {
      this.performSearch()
    }, 300)
  }

  private performSearch(): void {
    const query = this.inputTarget.value.trim()
    const url = new URL(this.urlValue, window.location.origin)

    if (query) {
      url.searchParams.set('q', query)
    }

    const frame = document.getElementById(this.frameValue)
    if (frame) {
      frame.setAttribute('src', url.toString())
    }

    const pageUrl = new URL(window.location.href)
    if (query) {
      pageUrl.searchParams.set('q', query)
    } else {
      pageUrl.searchParams.delete('q')
    }
    window.history.replaceState({}, '', pageUrl.toString())
  }
}
